module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "color": "white",
      "margin": "0px"
    }
  }, [_c('div', {
    staticClass: "pull-left",
    staticStyle: {
      "color": "white",
      "font-size": "larger",
      "font-weight": "bold"
    }
  }, [(_vm.readyOrdersDisplay) ? _c('span', {
    staticStyle: {
      "color": "gold"
    }
  }, [_vm._v("KDS - Ready for Pickup")]) : _c('span', {
    staticStyle: {
      "color": "#caffc4"
    }
  }, [_vm._v("KDS - Need Preparation")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin": "2px 7px 1px 7px",
      "width": "2.5em",
      "font-weight": "bolder",
      "background-color": "floralwhite",
      "color": "darkred"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDetailView()
      }
    }
  }, [_vm._v(_vm._s((_vm.detailView) ? '-' : '+'))])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.$t('store_number')) + ": "), _c('b', [_vm._v(_vm._s(_vm.storeNumber))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.refreshDelay),
      expression: "refreshDelay"
    }]
  }, [(_vm.orderList && _vm.orderList.length) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "87%",
      "position": "fixed",
      "width": "100%"
    }
  }, [(_vm.detailView) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('swiper', {
    ref: "orderSwiper",
    staticClass: "panel-trans",
    staticStyle: {
      "height": "100%",
      "padding-top": "5px"
    },
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.orderList), function(order, index) {
    return (!order.hidden) ? _c('slide', {
      ref: 'slide' + order.checkdetails.chk_num,
      refInFor: true
    }, [_c('div', {
      directives: [{
        name: "observe-visibility",
        rawName: "v-observe-visibility",
        value: ({
          callback: _vm.visibilityChanged,
          once: true,
        }),
        expression: "{\r\n                    callback: visibilityChanged,\r\n                    once: true,\r\n                  }"
      }],
      ref: 'order' + order.checkdetails.chk_num,
      refInFor: true,
      class: {
        'panel': true,
        'panel-default': true,
        'box-shadow': true,
        'ready': _vm.readyOrdersDisplay,
        'panel-trans': _vm.panelAnimation[index],
          'panel-shrinking': _vm.panelShrink[index],
          'panel-fade': _vm.panelFade[index]
      },
      staticStyle: {
        "width": "230px"
      },
      attrs: {
        "id": order.checkdetails.chk_num
      },
      on: {
        "click": function($event) {
          return _vm.toggleOrderSelect(order)
        }
      }
    }, [_c('orderheader', {
      staticClass: "panel-heading",
      attrs: {
        "checkNum": order.checkdetails.chk_num,
        "revenueType": order.checkdetails.name,
        "firstName": order.checkdetails.first_name,
        "lastName": order.checkdetails.last_name,
        "time": (_vm.elapsedTime[index]) ? _vm.elapsedTime[index].time : '',
        "timeColour": (_vm.elapsedTime[index]) ? _vm.elapsedTime[index].colour : '',
        "postPay": order.postPay,
        "closedDate": order.checkdetails.chk_clsd_date_time
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "panel-body",
      staticStyle: {
        "height": "80%",
        "width": "100%"
      }
    }, [_c('div', {
      ref: 'loader' + order.checkdetails.chk_num,
      refInFor: true,
      staticClass: "loader",
      staticStyle: {
        "display": "none"
      }
    }), _vm._v(" "), _c('orderitems', {
      ref: 'orderItems' + order.checkdetails.chk_num,
      refInFor: true,
      attrs: {
        "orderId": parseInt(order.checkdetails.chk_num),
        "customerName": order.checkdetails.id
      },
      on: {
        "updateOrder": _vm.updateOrder,
        "hideOrder": _vm.hideOrder
      }
    })], 1)], 1)]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2)], 1) : _c('div', [_c('div', {
    staticStyle: {
      "margin": "5px"
    }
  }, [_c('swiper', {
    staticClass: "panel-trans",
    staticStyle: {
      "height": "95%",
      "width": "100%",
      "padding": "10px 0px"
    },
    attrs: {
      "options": _vm.swiperOptionDetailless
    }
  }, [_vm._l((_vm.orderList), function(order, index) {
    return _c('slide', {
      staticStyle: {
        "height": "25vh"
      }
    }, [_c('div', {
      ref: 'order' + order.checkdetails.chk_num,
      refInFor: true,
      class: {
        'panel': true,
        'panel-default': true,
        'box-shadow': true,
        'ready': _vm.readyOrdersDisplay,
        'panel-trans': _vm.panelAnimation[index],
          'panel-shrinking': _vm.panelShrink[index],
          'panel-fade': _vm.panelFade[index]
      },
      staticStyle: {
        "margin": "0px",
        "padding": "0px",
        "height": "24vh"
      },
      attrs: {
        "id": order.checkdetails.chk_num,
        "name": "panel"
      },
      on: {
        "click": function($event) {
          return _vm.toggleOrderSelect(order)
        }
      }
    }, [_c('orderheader', {
      staticClass: "panel-heading",
      staticStyle: {
        "height": "100%"
      },
      attrs: {
        "checkNum": order.checkdetails.chk_num,
        "revenueType": order.checkdetails.name,
        "firstName": order.checkdetails.first_name,
        "lastName": order.checkdetails.last_name,
        "time": (_vm.elapsedTime[index]) ? _vm.elapsedTime[index].time : '',
        "timeColour": (_vm.elapsedTime[index]) ? _vm.elapsedTime[index].colour : '',
        "postPay": order.postPay,
        "closedDate": order.checkdetails.chk_clsd_date_time,
        "recallDisplay": true,
        "id": order.checkdetails.id
      }
    })], 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2)], 1)])]) : _c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "87%",
      "position": "fixed",
      "width": "100%",
      "text-align": "center"
    }
  }, [(_vm.error) ? _c('h3', {
    staticStyle: {
      "color": "white",
      "margin": "20px"
    }
  }, [_vm._v("\r\n        " + _vm._s(_vm.error) + "\r\n      ")]) : _c('h3', {
    staticStyle: {
      "color": "white",
      "margin": "20px"
    }
  }, [_vm._v("\r\n        " + _vm._s(_vm.$t('no_orders')) + "\r\n      ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.refreshDelay),
      expression: "!refreshDelay"
    }],
    staticClass: "row",
    staticStyle: {
      "height": "87%",
      "position": "fixed",
      "width": "100%",
      "text-align": "center"
    }
  }, [_c('h3', {
    staticStyle: {
      "color": "white",
      "margin": "20px"
    }
  }, [_vm._v("\r\n        " + _vm._s(_vm.$t('loading')) + "...\r\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "position": "fixed",
      "bottom": "5px",
      "margin": "0px 0px -4px -1px",
      "width": "100%",
      "z-index": "20"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "padding": "0px 20px 0px 0px"
    }
  }, [(_vm.readyOrdersDisplay) ? _c('button', {
    staticClass: "btn btn-lg btn-block",
    staticStyle: {
      "height": "60px",
      "width": "185px",
      "background-color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.gotoKDSprep()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-left pull-left",
    staticStyle: {
      "margin": "2px 5px 0px 0px"
    }
  }), _vm._v("Go to Prep\r\n                ")]) : (_vm.showReady) ? _c('button', {
    staticClass: "btn btn-lg btn-block ",
    staticStyle: {
      "height": "60px",
      "width": "185px",
      "background-color": "gold"
    },
    on: {
      "click": function($event) {
        return _vm.gotoKDSready()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-right pull-left",
    staticStyle: {
      "margin": "2px 10px 0px 0px"
    }
  }), _vm._v("Go to Ready\r\n                ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "0px 10px"
    }
  }, [(_vm.orderList && _vm.orderList.length) ? _c('div', {
    staticClass: "btn btn-block btn-lg btn-default button-prev btn-modified pull-right",
    staticStyle: {
      "width": "120px",
      "background-color": "#00ffff"
    },
    attrs: {
      "slot": "button-prev"
    },
    on: {
      "click": function($event) {
        return _vm.deselectOrder(_vm.selectedOrder)
      }
    },
    slot: "button-prev"
  }, [_c('i', {
    staticClass: "fas fa-chevron-left"
  }), _vm._v(" " + _vm._s(_vm.$t('prev')) + "\r\n                ")]) : _vm._e()]), _vm._v(" "), _c('td', [(_vm.actionButton == 'bump') ? _c('button', {
    staticClass: "btn btn-block btn-lg btn-success",
    style: ('height: 60px; width: 100%;' +
      ((_vm.readyOrdersDisplay || !_vm.showReady) ? '' : 'background-color: darkorange;')),
    attrs: {
      "disabled": !_vm.selectedOrder
    },
    on: {
      "click": function($event) {
        return _vm.actionLaunch('bump')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-external-link-alt pull-left",
    staticStyle: {
      "margin": "2px 0px 0px 0px"
    }
  }), _vm._v(_vm._s(_vm.$t('bump_order')) + "\r\n                ")]) : (_vm.actionButton == 'ready') ? _c('button', {
    staticClass: "btn btn-block btn-lg btn-success",
    staticStyle: {
      "height": "60px",
      "width": "100%"
    },
    attrs: {
      "disabled": !_vm.selectedOrder
    },
    on: {
      "click": function($event) {
        return _vm.actionLaunch('ready')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-external-link-alt pull-left",
    staticStyle: {
      "margin": "2px 10px 0px 0px"
    }
  }), _vm._v("Mark as Ready\r\n                ")]) : (_vm.actionButton == 'return') ? _c('button', {
    staticClass: "btn btn-block btn-lg btn-success",
    staticStyle: {
      "height": "60px",
      "width": "100%",
      "background-color": "darkorange"
    },
    attrs: {
      "disabled": !_vm.selectedOrder
    },
    on: {
      "click": function($event) {
        return _vm.actionLaunch('recall')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-history pull-left",
    staticStyle: {
      "margin": "2px 10px 0px 0px"
    }
  }), _vm._v("Return To Prep\r\n                ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "0px 10px"
    }
  }, [(_vm.orderList && _vm.orderList.length) ? _c('div', {
    staticClass: "btn btn-block btn-lg  btn-default button-next btn-modified",
    staticStyle: {
      "width": "120px",
      "background-color": "#00ffff"
    },
    attrs: {
      "slot": "button-next"
    },
    on: {
      "click": function($event) {
        return _vm.deselectOrder(_vm.selectedOrder)
      }
    },
    slot: "button-next"
  }, [_vm._v(_vm._s(_vm.$t('next')) + " "), _c('i', {
    staticClass: "fas fa-chevron-right"
  })]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "0px 20px 0px 0px"
    }
  }, [_c('button', {
    staticClass: "btn btn-lg btn-block btn-danger pull-right",
    staticStyle: {
      "height": "60px",
      "width": "180px",
      "margin": "5px"
    },
    on: {
      "click": function($event) {
        return _vm.gotoRecallList()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-history pull-left",
    staticStyle: {
      "margin": "2px 5px 0px 0px"
    }
  }), _vm._v("Go to Recall\r\n                ")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dcdc7ad6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/KdsDisplay.vue
// module id = 537
// module chunks = 2